import { createSlice } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';

export const initialState = {
  loading: false,
  response: null,
  error: null,
};

export const customChatSlice = createSlice({
  name: SLICE.CUSTOM_CHAT,
  initialState,
  reducers: {
    sendMessage(state) {
      state.loading = true;
      state.response = null;
      state.error = null;
    },
    sendMessageSucceeded(state, action) {
      state.loading = false;
      state.response = action.payload;
    },
    sendMessageFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetChat() {
      return initialState;
    },
  },
});

export const { actions: customChatActions } = customChatSlice;
